/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DeleteTeamApiSettingsTeamsTeamIdDeleteParams,
  DreamScanFieldValues,
  DreamScanRuleTestRequest,
  DreamScanRuleTestResponse,
  DreamScanSettings,
  GetJobMapApiSettingsTeamJobMapGetParams,
  GithubAppStatus,
  HTTPValidationError,
  InviteMemberApiSettingsTeamInvitePost200,
  InviteMemberRequest,
  JobMapReport,
  NotificationSettings,
  RemoveMemberApiSettingsTeamMembersMemberIdDelete200,
  TeamDeletePreview,
  TeamDeleteResult,
  TeamInfoResponse,
  TrainLoopLinkFired,
  TrainLoopLinkThreshold,
  TrainLoopLinks,
  TrainLoopStatus,
  TransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost200,
  UpdateDreamScanRequest,
  UpdateNotificationSettingsRequest,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getTeamInfoApiSettingsTeamGetResponse200 = {
  data: TeamInfoResponse;
  status: 200;
};

export type getTeamInfoApiSettingsTeamGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTeamInfoApiSettingsTeamGetResponseSuccess =
  getTeamInfoApiSettingsTeamGetResponse200 & {
    headers: Headers;
  };
export type getTeamInfoApiSettingsTeamGetResponseError =
  getTeamInfoApiSettingsTeamGetResponse422 & {
    headers: Headers;
  };

export type getTeamInfoApiSettingsTeamGetResponse =
  | getTeamInfoApiSettingsTeamGetResponseSuccess
  | getTeamInfoApiSettingsTeamGetResponseError;

export const getGetTeamInfoApiSettingsTeamGetUrl = () => {
  return `/api/settings/team`;
};

/**
 * Get current team info + members. The members' names and emails
 * are personal data, so the read is recorded in the team's audit log
 * (TRA-1626); the row names no member.
 * @summary Get Team Info
 */
export const getTeamInfoApiSettingsTeamGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getTeamInfoApiSettingsTeamGetResponse> => {
  return orvalFetch<getTeamInfoApiSettingsTeamGetResponse>(
    getGetTeamInfoApiSettingsTeamGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTeamInfoApiSettingsTeamGetQueryKey = () => {
  return [`/api/settings/team`] as const;
};

export const getGetTeamInfoApiSettingsTeamGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTeamInfoApiSettingsTeamGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>
  > = ({ signal }) =>
    getTeamInfoApiSettingsTeamGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamInfoApiSettingsTeamGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>
>;
export type GetTeamInfoApiSettingsTeamGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTeamInfoApiSettingsTeamGet<
  TData = Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
          TError,
          Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamInfoApiSettingsTeamGet<
  TData = Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
          TError,
          Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamInfoApiSettingsTeamGet<
  TData = Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Team Info
 */

export function useGetTeamInfoApiSettingsTeamGet<
  TData = Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamInfoApiSettingsTeamGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTeamInfoApiSettingsTeamGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getDreamScanApiSettingsTeamDreamScanGetResponse200 = {
  data: DreamScanSettings;
  status: 200;
};

export type getDreamScanApiSettingsTeamDreamScanGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getDreamScanApiSettingsTeamDreamScanGetResponseSuccess =
  getDreamScanApiSettingsTeamDreamScanGetResponse200 & {
    headers: Headers;
  };
export type getDreamScanApiSettingsTeamDreamScanGetResponseError =
  getDreamScanApiSettingsTeamDreamScanGetResponse422 & {
    headers: Headers;
  };

export type getDreamScanApiSettingsTeamDreamScanGetResponse =
  | getDreamScanApiSettingsTeamDreamScanGetResponseSuccess
  | getDreamScanApiSettingsTeamDreamScanGetResponseError;

export const getGetDreamScanApiSettingsTeamDreamScanGetUrl = () => {
  return `/api/settings/team/dream-scan`;
};

/**
 * The team's review scan cap, scan rules, run days and second-review
 * limits with their global fallbacks (TRA-942, TRA-964, TRA-1062, TRA-1569).
 * @summary Get Dream Scan
 */
export const getDreamScanApiSettingsTeamDreamScanGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getDreamScanApiSettingsTeamDreamScanGetResponse> => {
  return orvalFetch<getDreamScanApiSettingsTeamDreamScanGetResponse>(
    getGetDreamScanApiSettingsTeamDreamScanGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDreamScanApiSettingsTeamDreamScanGetQueryKey = () => {
  return [`/api/settings/team/dream-scan`] as const;
};

export const getGetDreamScanApiSettingsTeamDreamScanGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDreamScanApiSettingsTeamDreamScanGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>
  > = ({ signal }) =>
    getDreamScanApiSettingsTeamDreamScanGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDreamScanApiSettingsTeamDreamScanGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>
>;
export type GetDreamScanApiSettingsTeamDreamScanGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetDreamScanApiSettingsTeamDreamScanGet<
  TData = Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
          TError,
          Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDreamScanApiSettingsTeamDreamScanGet<
  TData = Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
          TError,
          Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDreamScanApiSettingsTeamDreamScanGet<
  TData = Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Dream Scan
 */

export function useGetDreamScanApiSettingsTeamDreamScanGet<
  TData = Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDreamScanApiSettingsTeamDreamScanGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDreamScanApiSettingsTeamDreamScanGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateDreamScanApiSettingsTeamDreamScanPutResponse200 = {
  data: DreamScanSettings;
  status: 200;
};

export type updateDreamScanApiSettingsTeamDreamScanPutResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateDreamScanApiSettingsTeamDreamScanPutResponseSuccess =
  updateDreamScanApiSettingsTeamDreamScanPutResponse200 & {
    headers: Headers;
  };
export type updateDreamScanApiSettingsTeamDreamScanPutResponseError =
  updateDreamScanApiSettingsTeamDreamScanPutResponse422 & {
    headers: Headers;
  };

export type updateDreamScanApiSettingsTeamDreamScanPutResponse =
  | updateDreamScanApiSettingsTeamDreamScanPutResponseSuccess
  | updateDreamScanApiSettingsTeamDreamScanPutResponseError;

export const getUpdateDreamScanApiSettingsTeamDreamScanPutUrl = () => {
  return `/api/settings/team/dream-scan`;
};

/**
 * Set the team's scan cap, scan rules, run days and second-review
 * limits (TRA-942, TRA-964, TRA-1062, TRA-1078, TRA-1569 patch 4).
 *
 * Replaces every setting whole — the form reads then writes. Rules only
 * stop FUTURE judging; flags a newly-excluded tenant already has in the
 * queue stay reviewable, and its traces keep being collected.
 * Impersonation is read-only, so staff can't reach this write — team
 * members own their scan settings. `selection` and the three second-review
 * limits (`queue_depth`, `cut_size`, `good_share`) are the exception:
 * only TrainLoop staff (members of the team) may move them, so
 * a customer's save keeps the stored values instead of the request's. A
 * limit the request leaves out keeps its stored value; null clears it.
 * @summary Update Dream Scan
 */
export const updateDreamScanApiSettingsTeamDreamScanPut = async (
  updateDreamScanRequest: UpdateDreamScanRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<updateDreamScanApiSettingsTeamDreamScanPutResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<updateDreamScanApiSettingsTeamDreamScanPutResponse>(
    getUpdateDreamScanApiSettingsTeamDreamScanPutUrl(),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(updateDreamScanRequest),
    },
  );
};

export const getUpdateDreamScanApiSettingsTeamDreamScanPutMutationKey = () =>
  ["updateDreamScanApiSettingsTeamDreamScanPut"] as const;

export const getUpdateDreamScanApiSettingsTeamDreamScanPutMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDreamScanApiSettingsTeamDreamScanPut>>,
    TError,
    UpdateDreamScanApiSettingsTeamDreamScanPutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDreamScanApiSettingsTeamDreamScanPut>>,
  TError,
  UpdateDreamScanApiSettingsTeamDreamScanPutMutationVariables,
  TContext
> => {
  const mutationKey =
    getUpdateDreamScanApiSettingsTeamDreamScanPutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDreamScanApiSettingsTeamDreamScanPut>>,
    UpdateDreamScanApiSettingsTeamDreamScanPutMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateDreamScanApiSettingsTeamDreamScanPut(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDreamScanApiSettingsTeamDreamScanPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateDreamScanApiSettingsTeamDreamScanPut>>
  >;
export type UpdateDreamScanApiSettingsTeamDreamScanPutMutationBody =
  UpdateDreamScanRequest;
export type UpdateDreamScanApiSettingsTeamDreamScanPutMutationError =
  ErrorType<HTTPValidationError>;
export type UpdateDreamScanApiSettingsTeamDreamScanPutMutationVariables = {
  data: UpdateDreamScanRequest;
};

/**
 * @summary Update Dream Scan
 */
export const useUpdateDreamScanApiSettingsTeamDreamScanPut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDreamScanApiSettingsTeamDreamScanPut>>,
      TError,
      UpdateDreamScanApiSettingsTeamDreamScanPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateDreamScanApiSettingsTeamDreamScanPut>>,
  TError,
  UpdateDreamScanApiSettingsTeamDreamScanPutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateDreamScanApiSettingsTeamDreamScanPutMutationOptions(options),
    queryClient,
  );
};
export type getJobMapApiSettingsTeamJobMapGetResponse200 = {
  data: JobMapReport;
  status: 200;
};

export type getJobMapApiSettingsTeamJobMapGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getJobMapApiSettingsTeamJobMapGetResponseSuccess =
  getJobMapApiSettingsTeamJobMapGetResponse200 & {
    headers: Headers;
  };
export type getJobMapApiSettingsTeamJobMapGetResponseError =
  getJobMapApiSettingsTeamJobMapGetResponse422 & {
    headers: Headers;
  };

export type getJobMapApiSettingsTeamJobMapGetResponse =
  | getJobMapApiSettingsTeamJobMapGetResponseSuccess
  | getJobMapApiSettingsTeamJobMapGetResponseError;

export const getGetJobMapApiSettingsTeamJobMapGetUrl = (
  params?: GetJobMapApiSettingsTeamJobMapGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/settings/team/job-map?${stringifiedParams}`
    : `/api/settings/team/job-map`;
};

/**
 * The team's job map with each job's share of the runs the review
 * scan counted in the window (TRA-1513). Staff only and read only for
 * now, like the settings section that shows it.
 * @summary Get Job Map
 */
export const getJobMapApiSettingsTeamJobMapGet = async (
  params?: GetJobMapApiSettingsTeamJobMapGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getJobMapApiSettingsTeamJobMapGetResponse> => {
  return orvalFetch<getJobMapApiSettingsTeamJobMapGetResponse>(
    getGetJobMapApiSettingsTeamJobMapGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetJobMapApiSettingsTeamJobMapGetQueryKey = (
  params?: GetJobMapApiSettingsTeamJobMapGetParams,
) => {
  return [`/api/settings/team/job-map`, ...(params ? [params] : [])] as const;
};

export const getGetJobMapApiSettingsTeamJobMapGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetJobMapApiSettingsTeamJobMapGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetJobMapApiSettingsTeamJobMapGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>
  > = ({ signal }) =>
    getJobMapApiSettingsTeamJobMapGet(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetJobMapApiSettingsTeamJobMapGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>
>;
export type GetJobMapApiSettingsTeamJobMapGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetJobMapApiSettingsTeamJobMapGet<
  TData = Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | GetJobMapApiSettingsTeamJobMapGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
          TError,
          Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetJobMapApiSettingsTeamJobMapGet<
  TData = Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetJobMapApiSettingsTeamJobMapGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
          TError,
          Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetJobMapApiSettingsTeamJobMapGet<
  TData = Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetJobMapApiSettingsTeamJobMapGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Job Map
 */

export function useGetJobMapApiSettingsTeamJobMapGet<
  TData = Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetJobMapApiSettingsTeamJobMapGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobMapApiSettingsTeamJobMapGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetJobMapApiSettingsTeamJobMapGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetResponse200 =
  {
    data: DreamScanFieldValues;
    status: 200;
  };

export type getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetResponseSuccess =
  getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetResponse200 & {
    headers: Headers;
  };
export type getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetResponseError =
  getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetResponse422 & {
    headers: Headers;
  };

export type getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetResponse =

    | getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetResponseSuccess
    | getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetResponseError;

export const getGetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetUrl =
  () => {
    return `/api/settings/team/dream-scan/field-values`;
  };

/**
 * Observed values per field, for the rule editor's suggestions.
 * @summary Get Dream Scan Field Values
 */
export const getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet =
  async (
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetResponse> => {
    return orvalFetch<getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetResponse>(
      getGetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetUrl(),
      {
        ...options,
        method: "GET",
      },
    );
  };

export const getGetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetQueryKey =
  () => {
    return [`/api/settings/team/dream-scan/field-values`] as const;
  };

export const getGetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
        >
      >
    > = ({ signal }) =>
      getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet({
        signal,
        ...requestOptions,
      });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
      >
    >
  >;
export type GetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet<
  TData = Awaited<
    ReturnType<
      typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet<
  TData = Awaited<
    ReturnType<
      typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet<
  TData = Awaited<
    ReturnType<
      typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Dream Scan Field Values
 */

export function useGetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet<
  TData = Awaited<
    ReturnType<
      typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDreamScanFieldValuesApiSettingsTeamDreamScanFieldValuesGetQueryOptions(
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type testDreamScanRulesApiSettingsTeamDreamScanRulesTestPostResponse200 =
  {
    data: DreamScanRuleTestResponse;
    status: 200;
  };

export type testDreamScanRulesApiSettingsTeamDreamScanRulesTestPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type testDreamScanRulesApiSettingsTeamDreamScanRulesTestPostResponseSuccess =
  testDreamScanRulesApiSettingsTeamDreamScanRulesTestPostResponse200 & {
    headers: Headers;
  };
export type testDreamScanRulesApiSettingsTeamDreamScanRulesTestPostResponseError =
  testDreamScanRulesApiSettingsTeamDreamScanRulesTestPostResponse422 & {
    headers: Headers;
  };

export type testDreamScanRulesApiSettingsTeamDreamScanRulesTestPostResponse =
  | testDreamScanRulesApiSettingsTeamDreamScanRulesTestPostResponseSuccess
  | testDreamScanRulesApiSettingsTeamDreamScanRulesTestPostResponseError;

export const getTestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostUrl =
  () => {
    return `/api/settings/team/dream-scan/rules-test`;
  };

/**
 * Preview draft rules against the team's observed traces (TRA-1062).
 *
 * Writes nothing. Observed traces are the team's `trace_filter_cache`
 * rows, grouped into distinct combinations of the fields the rules
 * reference. The verdict logic is apply_scan_rules', but the UNIT is one
 * observed trace: the review scan decides once per conversation (by its
 * first trace), and the cache holds no trajectory grouping, so this is a
 * per-trace approximation and says so in the schema and the UI.
 *
 * A team past RULE_TEST_TRACE_LIMIT gets a deterministic sample flagged
 * via `sampled` — never a silent truncation. Descending key order biases
 * the sample toward recent days (keys embed the date), but within one
 * day the UUID segments make the order arbitrary, so the response never
 * claims recency beyond that.
 * @summary Test Dream Scan Rules
 */
export const testDreamScanRulesApiSettingsTeamDreamScanRulesTestPost = async (
  dreamScanRuleTestRequest: DreamScanRuleTestRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<testDreamScanRulesApiSettingsTeamDreamScanRulesTestPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<testDreamScanRulesApiSettingsTeamDreamScanRulesTestPostResponse>(
    getTestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(dreamScanRuleTestRequest),
    },
  );
};

export const getTestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationKey =
  () => ["testDreamScanRulesApiSettingsTeamDreamScanRulesTestPost"] as const;

export const getTestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof testDreamScanRulesApiSettingsTeamDreamScanRulesTestPost
        >
      >,
      TError,
      TestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof testDreamScanRulesApiSettingsTeamDreamScanRulesTestPost>
    >,
    TError,
    TestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getTestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof testDreamScanRulesApiSettingsTeamDreamScanRulesTestPost
        >
      >,
      TestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return testDreamScanRulesApiSettingsTeamDreamScanRulesTestPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof testDreamScanRulesApiSettingsTeamDreamScanRulesTestPost>
    >
  >;
export type TestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationBody =
  DreamScanRuleTestRequest;
export type TestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationError =
  ErrorType<HTTPValidationError>;
export type TestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationVariables =
  { data: DreamScanRuleTestRequest };

/**
 * @summary Test Dream Scan Rules
 */
export const useTestDreamScanRulesApiSettingsTeamDreamScanRulesTestPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof testDreamScanRulesApiSettingsTeamDreamScanRulesTestPost
        >
      >,
      TError,
      TestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof testDreamScanRulesApiSettingsTeamDreamScanRulesTestPost>
  >,
  TError,
  TestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationVariables,
  TContext
> => {
  return useMutation(
    getTestDreamScanRulesApiSettingsTeamDreamScanRulesTestPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type getNotificationSettingsApiSettingsTeamNotificationsGetResponse200 =
  {
    data: NotificationSettings;
    status: 200;
  };

export type getNotificationSettingsApiSettingsTeamNotificationsGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type getNotificationSettingsApiSettingsTeamNotificationsGetResponseSuccess =
  getNotificationSettingsApiSettingsTeamNotificationsGetResponse200 & {
    headers: Headers;
  };
export type getNotificationSettingsApiSettingsTeamNotificationsGetResponseError =
  getNotificationSettingsApiSettingsTeamNotificationsGetResponse422 & {
    headers: Headers;
  };

export type getNotificationSettingsApiSettingsTeamNotificationsGetResponse =
  | getNotificationSettingsApiSettingsTeamNotificationsGetResponseSuccess
  | getNotificationSettingsApiSettingsTeamNotificationsGetResponseError;

export const getGetNotificationSettingsApiSettingsTeamNotificationsGetUrl =
  () => {
    return `/api/settings/team/notifications`;
  };

/**
 * Where failure alerts for this team get delivered (TRA-1068). The
 * callback URL is as good as a credential, so the read is recorded in
 * the team's audit log (TRA-1626); the row never carries the URL.
 * @summary Get Notification Settings
 */
export const getNotificationSettingsApiSettingsTeamNotificationsGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getNotificationSettingsApiSettingsTeamNotificationsGetResponse> => {
  return orvalFetch<getNotificationSettingsApiSettingsTeamNotificationsGetResponse>(
    getGetNotificationSettingsApiSettingsTeamNotificationsGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNotificationSettingsApiSettingsTeamNotificationsGetQueryKey =
  () => {
    return [`/api/settings/team/notifications`] as const;
  };

export const getGetNotificationSettingsApiSettingsTeamNotificationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getNotificationSettingsApiSettingsTeamNotificationsGet>
    >,
    TError = ErrorType<HTTPValidationError>,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNotificationSettingsApiSettingsTeamNotificationsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetNotificationSettingsApiSettingsTeamNotificationsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getNotificationSettingsApiSettingsTeamNotificationsGet
        >
      >
    > = ({ signal }) =>
      getNotificationSettingsApiSettingsTeamNotificationsGet({
        signal,
        ...requestOptions,
      });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getNotificationSettingsApiSettingsTeamNotificationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetNotificationSettingsApiSettingsTeamNotificationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getNotificationSettingsApiSettingsTeamNotificationsGet>
    >
  >;
export type GetNotificationSettingsApiSettingsTeamNotificationsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetNotificationSettingsApiSettingsTeamNotificationsGet<
  TData = Awaited<
    ReturnType<typeof getNotificationSettingsApiSettingsTeamNotificationsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNotificationSettingsApiSettingsTeamNotificationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getNotificationSettingsApiSettingsTeamNotificationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getNotificationSettingsApiSettingsTeamNotificationsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationSettingsApiSettingsTeamNotificationsGet<
  TData = Awaited<
    ReturnType<typeof getNotificationSettingsApiSettingsTeamNotificationsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNotificationSettingsApiSettingsTeamNotificationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getNotificationSettingsApiSettingsTeamNotificationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getNotificationSettingsApiSettingsTeamNotificationsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationSettingsApiSettingsTeamNotificationsGet<
  TData = Awaited<
    ReturnType<typeof getNotificationSettingsApiSettingsTeamNotificationsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNotificationSettingsApiSettingsTeamNotificationsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Notification Settings
 */

export function useGetNotificationSettingsApiSettingsTeamNotificationsGet<
  TData = Awaited<
    ReturnType<typeof getNotificationSettingsApiSettingsTeamNotificationsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNotificationSettingsApiSettingsTeamNotificationsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetNotificationSettingsApiSettingsTeamNotificationsGetQueryOptions(
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateNotificationSettingsApiSettingsTeamNotificationsPutResponse200 =
  {
    data: NotificationSettings;
    status: 200;
  };

export type updateNotificationSettingsApiSettingsTeamNotificationsPutResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type updateNotificationSettingsApiSettingsTeamNotificationsPutResponseSuccess =
  updateNotificationSettingsApiSettingsTeamNotificationsPutResponse200 & {
    headers: Headers;
  };
export type updateNotificationSettingsApiSettingsTeamNotificationsPutResponseError =
  updateNotificationSettingsApiSettingsTeamNotificationsPutResponse422 & {
    headers: Headers;
  };

export type updateNotificationSettingsApiSettingsTeamNotificationsPutResponse =
  | updateNotificationSettingsApiSettingsTeamNotificationsPutResponseSuccess
  | updateNotificationSettingsApiSettingsTeamNotificationsPutResponseError;

export const getUpdateNotificationSettingsApiSettingsTeamNotificationsPutUrl =
  () => {
    return `/api/settings/team/notifications`;
  };

/**
 * Set the team's failure-alert callback URL + signing secret (TRA-1068).
 *
 * The URL replaces whole — the form reads then writes; clearing it also
 * clears the secret. The secret is write-only (encrypted at rest, never
 * returned), so an empty secret keeps the stored one and removal is the
 * explicit `clear_signing_secret` flag. Custom endpoints require a signing
 * secret. Native Slack authenticates with the webhook URL.
 * Impersonation is read-only, so staff can't reach this
 * write — team members own their callback.
 * @summary Update Notification Settings
 */
export const updateNotificationSettingsApiSettingsTeamNotificationsPut = async (
  updateNotificationSettingsRequest: UpdateNotificationSettingsRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<updateNotificationSettingsApiSettingsTeamNotificationsPutResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<updateNotificationSettingsApiSettingsTeamNotificationsPutResponse>(
    getUpdateNotificationSettingsApiSettingsTeamNotificationsPutUrl(),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(updateNotificationSettingsRequest),
    },
  );
};

export const getUpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationKey =
  () => ["updateNotificationSettingsApiSettingsTeamNotificationsPut"] as const;

export const getUpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateNotificationSettingsApiSettingsTeamNotificationsPut
        >
      >,
      TError,
      UpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateNotificationSettingsApiSettingsTeamNotificationsPut
      >
    >,
    TError,
    UpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getUpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateNotificationSettingsApiSettingsTeamNotificationsPut
        >
      >,
      UpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return updateNotificationSettingsApiSettingsTeamNotificationsPut(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateNotificationSettingsApiSettingsTeamNotificationsPut
      >
    >
  >;
export type UpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationBody =
  UpdateNotificationSettingsRequest;
export type UpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationError =
  ErrorType<HTTPValidationError>;
export type UpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationVariables =
  { data: UpdateNotificationSettingsRequest };

/**
 * @summary Update Notification Settings
 */
export const useUpdateNotificationSettingsApiSettingsTeamNotificationsPut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateNotificationSettingsApiSettingsTeamNotificationsPut
        >
      >,
      TError,
      UpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateNotificationSettingsApiSettingsTeamNotificationsPut>
  >,
  TError,
  UpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateNotificationSettingsApiSettingsTeamNotificationsPutMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type inviteMemberApiSettingsTeamInvitePostResponse200 = {
  data: InviteMemberApiSettingsTeamInvitePost200;
  status: 200;
};

export type inviteMemberApiSettingsTeamInvitePostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type inviteMemberApiSettingsTeamInvitePostResponseSuccess =
  inviteMemberApiSettingsTeamInvitePostResponse200 & {
    headers: Headers;
  };
export type inviteMemberApiSettingsTeamInvitePostResponseError =
  inviteMemberApiSettingsTeamInvitePostResponse422 & {
    headers: Headers;
  };

export type inviteMemberApiSettingsTeamInvitePostResponse =
  | inviteMemberApiSettingsTeamInvitePostResponseSuccess
  | inviteMemberApiSettingsTeamInvitePostResponseError;

export const getInviteMemberApiSettingsTeamInvitePostUrl = () => {
  return `/api/settings/team/invite`;
};

/**
 * Invite a member by email. Only the team owner can (TRA-1626: any
 * member could before, which let one member open the team's data to
 * anyone with an account), the same gate as removing a member. The
 * invite, and a refused one, go to the team's audit log.
 * @summary Invite Member
 */
export const inviteMemberApiSettingsTeamInvitePost = async (
  inviteMemberRequest: InviteMemberRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<inviteMemberApiSettingsTeamInvitePostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<inviteMemberApiSettingsTeamInvitePostResponse>(
    getInviteMemberApiSettingsTeamInvitePostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(inviteMemberRequest),
    },
  );
};

export const getInviteMemberApiSettingsTeamInvitePostMutationKey = () =>
  ["inviteMemberApiSettingsTeamInvitePost"] as const;

export const getInviteMemberApiSettingsTeamInvitePostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteMemberApiSettingsTeamInvitePost>>,
    TError,
    InviteMemberApiSettingsTeamInvitePostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteMemberApiSettingsTeamInvitePost>>,
  TError,
  InviteMemberApiSettingsTeamInvitePostMutationVariables,
  TContext
> => {
  const mutationKey = getInviteMemberApiSettingsTeamInvitePostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteMemberApiSettingsTeamInvitePost>>,
    InviteMemberApiSettingsTeamInvitePostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return inviteMemberApiSettingsTeamInvitePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteMemberApiSettingsTeamInvitePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteMemberApiSettingsTeamInvitePost>>
>;
export type InviteMemberApiSettingsTeamInvitePostMutationBody =
  InviteMemberRequest;
export type InviteMemberApiSettingsTeamInvitePostMutationError =
  ErrorType<HTTPValidationError>;
export type InviteMemberApiSettingsTeamInvitePostMutationVariables = {
  data: InviteMemberRequest;
};

/**
 * @summary Invite Member
 */
export const useInviteMemberApiSettingsTeamInvitePost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof inviteMemberApiSettingsTeamInvitePost>>,
      TError,
      InviteMemberApiSettingsTeamInvitePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof inviteMemberApiSettingsTeamInvitePost>>,
  TError,
  InviteMemberApiSettingsTeamInvitePostMutationVariables,
  TContext
> => {
  return useMutation(
    getInviteMemberApiSettingsTeamInvitePostMutationOptions(options),
    queryClient,
  );
};
export type removeMemberApiSettingsTeamMembersMemberIdDeleteResponse200 = {
  data: RemoveMemberApiSettingsTeamMembersMemberIdDelete200;
  status: 200;
};

export type removeMemberApiSettingsTeamMembersMemberIdDeleteResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type removeMemberApiSettingsTeamMembersMemberIdDeleteResponseSuccess =
  removeMemberApiSettingsTeamMembersMemberIdDeleteResponse200 & {
    headers: Headers;
  };
export type removeMemberApiSettingsTeamMembersMemberIdDeleteResponseError =
  removeMemberApiSettingsTeamMembersMemberIdDeleteResponse422 & {
    headers: Headers;
  };

export type removeMemberApiSettingsTeamMembersMemberIdDeleteResponse =
  | removeMemberApiSettingsTeamMembersMemberIdDeleteResponseSuccess
  | removeMemberApiSettingsTeamMembersMemberIdDeleteResponseError;

export const getRemoveMemberApiSettingsTeamMembersMemberIdDeleteUrl = (
  memberId: string,
) => {
  return `/api/settings/team/members/${memberId}`;
};

/**
 * Remove a member from the team (also used for leaving: member_id == self).
 *
 * Three guards:
 * - Only the owner may remove OTHER members; anyone may remove themselves
 *   (leave). Mirrors the owner gate on transfer_team_ownership.
 * - The owner can't be removed (transfer ownership first).
 * - Members whose email domain is one of the team's auto-join
 *   email_domains can't be removed or leave — auto-join would re-add
 *   them on their next sign-in anyway, so removal would be a lie.
 *   Cross-domain members (invited contractors, staff) can leave freely.
 *
 * The removal (`member.remove`, or `member.leave` for oneself) goes to
 * the team's audit log once Keycloak accepted it (TRA-1626).
 * @summary Remove Member
 */
export const removeMemberApiSettingsTeamMembersMemberIdDelete = async (
  memberId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<removeMemberApiSettingsTeamMembersMemberIdDeleteResponse> => {
  return orvalFetch<removeMemberApiSettingsTeamMembersMemberIdDeleteResponse>(
    getRemoveMemberApiSettingsTeamMembersMemberIdDeleteUrl(memberId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationKey =
  () => ["removeMemberApiSettingsTeamMembersMemberIdDelete"] as const;

export const getRemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof removeMemberApiSettingsTeamMembersMemberIdDelete>
      >,
      TError,
      RemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof removeMemberApiSettingsTeamMembersMemberIdDelete>
    >,
    TError,
    RemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationVariables,
    TContext
  > => {
    const mutationKey =
      getRemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof removeMemberApiSettingsTeamMembersMemberIdDelete>
      >,
      RemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationVariables
    > = (props) => {
      const { memberId } = props ?? {};

      return removeMemberApiSettingsTeamMembersMemberIdDelete(
        memberId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof removeMemberApiSettingsTeamMembersMemberIdDelete>>
  >;

export type RemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationError =
  ErrorType<HTTPValidationError>;
export type RemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationVariables =
  { memberId: string };

/**
 * @summary Remove Member
 */
export const useRemoveMemberApiSettingsTeamMembersMemberIdDelete = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof removeMemberApiSettingsTeamMembersMemberIdDelete>
      >,
      TError,
      RemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeMemberApiSettingsTeamMembersMemberIdDelete>>,
  TError,
  RemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getRemoveMemberApiSettingsTeamMembersMemberIdDeleteMutationOptions(options),
    queryClient,
  );
};
export type transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostResponse200 =
  {
    data: TransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost200;
    status: 200;
  };

export type transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostResponseSuccess =
  transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostResponse200 & {
    headers: Headers;
  };
export type transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostResponseError =
  transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostResponse422 & {
    headers: Headers;
  };

export type transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostResponse =

    | transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostResponseSuccess
    | transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostResponseError;

export const getTransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostUrl =
  (memberId: string) => {
    return `/api/settings/team/members/${memberId}/transfer-ownership`;
  };

/**
 * Transfer team ownership to another member.
 *
 * Teams have exactly one owner. Only the current owner can transfer;
 * the target must already be a member; the caller stops being owner
 * (the new owner can transfer it back if needed). The old and new owner
 * go to the team's audit log once Keycloak accepted it (TRA-1626).
 * @summary Transfer Team Ownership
 */
export const transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost =
  async (
    memberId: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostResponse> => {
    return orvalFetch<transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostResponse>(
      getTransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostUrl(
        memberId,
      ),
      {
        ...options,
        method: "POST",
      },
    );
  };

export const getTransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationKey =
  () =>
    [
      "transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost",
    ] as const;

export const getTransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost
        >
      >,
      TError,
      TransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost
      >
    >,
    TError,
    TransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getTransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost
        >
      >,
      TransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationVariables
    > = (props) => {
      const { memberId } = props ?? {};

      return transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost(
        memberId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost
      >
    >
  >;

export type TransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationError =
  ErrorType<HTTPValidationError>;
export type TransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationVariables =
  { memberId: string };

/**
 * @summary Transfer Team Ownership
 */
export const useTransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost
          >
        >,
        TError,
        TransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof transferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPost
      >
    >,
    TError,
    TransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationVariables,
    TContext
  > => {
    return useMutation(
      getTransferTeamOwnershipApiSettingsTeamMembersMemberIdTransferOwnershipPostMutationOptions(
        options,
      ),
      queryClient,
    );
  };
export type getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetResponse200 =
  {
    data: TeamDeletePreview;
    status: 200;
  };

export type getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetResponseSuccess =
  getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetResponse200 & {
    headers: Headers;
  };
export type getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetResponseError =
  getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetResponse422 & {
    headers: Headers;
  };

export type getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetResponse =
  | getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetResponseSuccess
  | getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetResponseError;

export const getGetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetUrl =
  (teamId: string) => {
    return `/api/settings/teams/${teamId}/delete-preview`;
  };

/**
 * What deleting the team would remove, for the owner's confirm dialog.
 * @summary Get Team Delete Preview
 */
export const getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet =
  async (
    teamId: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetResponse> => {
    return orvalFetch<getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetResponse>(
      getGetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetUrl(teamId),
      {
        ...options,
        method: "GET",
      },
    );
  };

export const getGetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetQueryKey =
  (teamId: string) => {
    return [`/api/settings/teams/${teamId}/delete-preview`] as const;
  };

export const getGetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    teamId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetQueryKey(
        teamId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
        >
      >
    > = ({ signal }) =>
      getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet(teamId, {
        signal,
        ...requestOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled: teamId !== null && teamId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
      >
    >
  >;
export type GetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Team Delete Preview
 */

export function useGetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTeamDeletePreviewApiSettingsTeamsTeamIdDeletePreviewGetQueryOptions(
      teamId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deleteTeamApiSettingsTeamsTeamIdDeleteResponse200 = {
  data: TeamDeleteResult;
  status: 200;
};

export type deleteTeamApiSettingsTeamsTeamIdDeleteResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteTeamApiSettingsTeamsTeamIdDeleteResponseSuccess =
  deleteTeamApiSettingsTeamsTeamIdDeleteResponse200 & {
    headers: Headers;
  };
export type deleteTeamApiSettingsTeamsTeamIdDeleteResponseError =
  deleteTeamApiSettingsTeamsTeamIdDeleteResponse422 & {
    headers: Headers;
  };

export type deleteTeamApiSettingsTeamsTeamIdDeleteResponse =
  | deleteTeamApiSettingsTeamsTeamIdDeleteResponseSuccess
  | deleteTeamApiSettingsTeamsTeamIdDeleteResponseError;

export const getDeleteTeamApiSettingsTeamsTeamIdDeleteUrl = (
  teamId: string,
  params: DeleteTeamApiSettingsTeamsTeamIdDeleteParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/settings/teams/${teamId}?${stringifiedParams}`
    : `/api/settings/teams/${teamId}`;
};

/**
 * Delete a team and everything it owns (services/team_delete.py).
 *
 * Only the team owner can delete a team, and not their last one. The
 * server checks the typed name too, and refuses while a Job or a
 * training run of the team is active or the team is protected.
 * @summary Delete Team
 */
export const deleteTeamApiSettingsTeamsTeamIdDelete = async (
  teamId: string,
  params: DeleteTeamApiSettingsTeamsTeamIdDeleteParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<deleteTeamApiSettingsTeamsTeamIdDeleteResponse> => {
  return orvalFetch<deleteTeamApiSettingsTeamsTeamIdDeleteResponse>(
    getDeleteTeamApiSettingsTeamsTeamIdDeleteUrl(teamId, params),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteTeamApiSettingsTeamsTeamIdDeleteMutationKey = () =>
  ["deleteTeamApiSettingsTeamsTeamIdDelete"] as const;

export const getDeleteTeamApiSettingsTeamsTeamIdDeleteMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeamApiSettingsTeamsTeamIdDelete>>,
    TError,
    DeleteTeamApiSettingsTeamsTeamIdDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTeamApiSettingsTeamsTeamIdDelete>>,
  TError,
  DeleteTeamApiSettingsTeamsTeamIdDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteTeamApiSettingsTeamsTeamIdDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTeamApiSettingsTeamsTeamIdDelete>>,
    DeleteTeamApiSettingsTeamsTeamIdDeleteMutationVariables
  > = (props) => {
    const { teamId, params } = props ?? {};

    return deleteTeamApiSettingsTeamsTeamIdDelete(
      teamId,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTeamApiSettingsTeamsTeamIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTeamApiSettingsTeamsTeamIdDelete>>
>;

export type DeleteTeamApiSettingsTeamsTeamIdDeleteMutationError =
  ErrorType<HTTPValidationError>;
export type DeleteTeamApiSettingsTeamsTeamIdDeleteMutationVariables = {
  teamId: string;
  params: DeleteTeamApiSettingsTeamsTeamIdDeleteParams;
};

/**
 * @summary Delete Team
 */
export const useDeleteTeamApiSettingsTeamsTeamIdDelete = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTeamApiSettingsTeamsTeamIdDelete>>,
      TError,
      DeleteTeamApiSettingsTeamsTeamIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTeamApiSettingsTeamsTeamIdDelete>>,
  TError,
  DeleteTeamApiSettingsTeamsTeamIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getDeleteTeamApiSettingsTeamsTeamIdDeleteMutationOptions(options),
    queryClient,
  );
};
export type getGithubAppStatusApiSettingsTeamGithubAppGetResponse200 = {
  data: GithubAppStatus;
  status: 200;
};

export type getGithubAppStatusApiSettingsTeamGithubAppGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getGithubAppStatusApiSettingsTeamGithubAppGetResponseSuccess =
  getGithubAppStatusApiSettingsTeamGithubAppGetResponse200 & {
    headers: Headers;
  };
export type getGithubAppStatusApiSettingsTeamGithubAppGetResponseError =
  getGithubAppStatusApiSettingsTeamGithubAppGetResponse422 & {
    headers: Headers;
  };

export type getGithubAppStatusApiSettingsTeamGithubAppGetResponse =
  | getGithubAppStatusApiSettingsTeamGithubAppGetResponseSuccess
  | getGithubAppStatusApiSettingsTeamGithubAppGetResponseError;

export const getGetGithubAppStatusApiSettingsTeamGithubAppGetUrl = () => {
  return `/api/settings/team/github-app`;
};

/**
 * Whether the TrainLoop GitHub App is installed for this team, where,
 * and which repositories it covers (Settings > GitHub App). Asked of
 * GitHub on every call, so a customer who just installed the App sees
 * it here without waiting for a nightly. A missing, revoked or
 * uncheckable installation is a status in the body, never an error:
 * the page renders the next step from it.
 * @summary Get Github App Status
 */
export const getGithubAppStatusApiSettingsTeamGithubAppGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getGithubAppStatusApiSettingsTeamGithubAppGetResponse> => {
  return orvalFetch<getGithubAppStatusApiSettingsTeamGithubAppGetResponse>(
    getGetGithubAppStatusApiSettingsTeamGithubAppGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetGithubAppStatusApiSettingsTeamGithubAppGetQueryKey = () => {
  return [`/api/settings/team/github-app`] as const;
};

export const getGetGithubAppStatusApiSettingsTeamGithubAppGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetGithubAppStatusApiSettingsTeamGithubAppGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>>
  > = ({ signal }) =>
    getGithubAppStatusApiSettingsTeamGithubAppGet({
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGithubAppStatusApiSettingsTeamGithubAppGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>>
  >;
export type GetGithubAppStatusApiSettingsTeamGithubAppGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetGithubAppStatusApiSettingsTeamGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGithubAppStatusApiSettingsTeamGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGithubAppStatusApiSettingsTeamGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Github App Status
 */

export function useGetGithubAppStatusApiSettingsTeamGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getGithubAppStatusApiSettingsTeamGithubAppGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetGithubAppStatusApiSettingsTeamGithubAppGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getTrainLoopApiSettingsTeamTrainLoopGetResponse200 = {
  data: TrainLoopStatus;
  status: 200;
};

export type getTrainLoopApiSettingsTeamTrainLoopGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTrainLoopApiSettingsTeamTrainLoopGetResponseSuccess =
  getTrainLoopApiSettingsTeamTrainLoopGetResponse200 & {
    headers: Headers;
  };
export type getTrainLoopApiSettingsTeamTrainLoopGetResponseError =
  getTrainLoopApiSettingsTeamTrainLoopGetResponse422 & {
    headers: Headers;
  };

export type getTrainLoopApiSettingsTeamTrainLoopGetResponse =
  | getTrainLoopApiSettingsTeamTrainLoopGetResponseSuccess
  | getTrainLoopApiSettingsTeamTrainLoopGetResponseError;

export const getGetTrainLoopApiSettingsTeamTrainLoopGetUrl = () => {
  return `/api/settings/team/train-loop`;
};

/**
 * Every stage of the train loop and whether it runs for this team
 * (Settings > Pipeline). A missing piece is a state in the body. The
 * default model's trace logging is read from the gateway, so a gateway
 * that cannot answer is a 502 rather than a guessed monitor state.
 * @summary Get Train Loop
 */
export const getTrainLoopApiSettingsTeamTrainLoopGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getTrainLoopApiSettingsTeamTrainLoopGetResponse> => {
  return orvalFetch<getTrainLoopApiSettingsTeamTrainLoopGetResponse>(
    getGetTrainLoopApiSettingsTeamTrainLoopGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTrainLoopApiSettingsTeamTrainLoopGetQueryKey = () => {
  return [`/api/settings/team/train-loop`] as const;
};

export const getGetTrainLoopApiSettingsTeamTrainLoopGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTrainLoopApiSettingsTeamTrainLoopGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>
  > = ({ signal }) =>
    getTrainLoopApiSettingsTeamTrainLoopGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrainLoopApiSettingsTeamTrainLoopGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>
>;
export type GetTrainLoopApiSettingsTeamTrainLoopGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTrainLoopApiSettingsTeamTrainLoopGet<
  TData = Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
          TError,
          Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainLoopApiSettingsTeamTrainLoopGet<
  TData = Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
          TError,
          Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainLoopApiSettingsTeamTrainLoopGet<
  TData = Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Train Loop
 */

export function useGetTrainLoopApiSettingsTeamTrainLoopGet<
  TData = Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrainLoopApiSettingsTeamTrainLoopGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTrainLoopApiSettingsTeamTrainLoopGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getTrainLoopLinksApiSettingsTeamTrainLoopLinksGetResponse200 = {
  data: TrainLoopLinks;
  status: 200;
};

export type getTrainLoopLinksApiSettingsTeamTrainLoopLinksGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTrainLoopLinksApiSettingsTeamTrainLoopLinksGetResponseSuccess =
  getTrainLoopLinksApiSettingsTeamTrainLoopLinksGetResponse200 & {
    headers: Headers;
  };
export type getTrainLoopLinksApiSettingsTeamTrainLoopLinksGetResponseError =
  getTrainLoopLinksApiSettingsTeamTrainLoopLinksGetResponse422 & {
    headers: Headers;
  };

export type getTrainLoopLinksApiSettingsTeamTrainLoopLinksGetResponse =
  | getTrainLoopLinksApiSettingsTeamTrainLoopLinksGetResponseSuccess
  | getTrainLoopLinksApiSettingsTeamTrainLoopLinksGetResponseError;

export const getGetTrainLoopLinksApiSettingsTeamTrainLoopLinksGetUrl = () => {
  return `/api/settings/team/train-loop/links`;
};

/**
 * Every link of the pipeline for this team: what starts it, what
 * waits for it now, and its last run. A team with no jobs set up has no
 * links. The cluster is read once; a stack outside Kubernetes answers
 * 503, since the links are its Jobs.
 * @summary Get Train Loop Links
 */
export const getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getTrainLoopLinksApiSettingsTeamTrainLoopLinksGetResponse> => {
  return orvalFetch<getTrainLoopLinksApiSettingsTeamTrainLoopLinksGetResponse>(
    getGetTrainLoopLinksApiSettingsTeamTrainLoopLinksGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTrainLoopLinksApiSettingsTeamTrainLoopLinksGetQueryKey =
  () => {
    return [`/api/settings/team/train-loop/links`] as const;
  };

export const getGetTrainLoopLinksApiSettingsTeamTrainLoopLinksGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
    >,
    TError = ErrorType<HTTPValidationError>,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTrainLoopLinksApiSettingsTeamTrainLoopLinksGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
      >
    > = ({ signal }) =>
      getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet({
        signal,
        ...requestOptions,
      });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTrainLoopLinksApiSettingsTeamTrainLoopLinksGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
    >
  >;
export type GetTrainLoopLinksApiSettingsTeamTrainLoopLinksGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTrainLoopLinksApiSettingsTeamTrainLoopLinksGet<
  TData = Awaited<
    ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainLoopLinksApiSettingsTeamTrainLoopLinksGet<
  TData = Awaited<
    ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainLoopLinksApiSettingsTeamTrainLoopLinksGet<
  TData = Awaited<
    ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Train Loop Links
 */

export function useGetTrainLoopLinksApiSettingsTeamTrainLoopLinksGet<
  TData = Awaited<
    ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTrainLoopLinksApiSettingsTeamTrainLoopLinksGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTrainLoopLinksApiSettingsTeamTrainLoopLinksGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostResponse200 =
  {
    data: TrainLoopLinkFired;
    status: 200;
  };

export type runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostResponseSuccess =
  runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostResponse200 & {
    headers: Headers;
  };
export type runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostResponseError =
  runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostResponse422 & {
    headers: Headers;
  };

export type runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostResponse =
  | runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostResponseSuccess
  | runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostResponseError;

export const getRunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostUrl = (
  slug: string,
) => {
  return `/api/settings/team/train-loop/links/${slug}/run`;
};

/**
 * Start one link now on whatever waits: the job's own rule, then
 * its condition, then the cluster. Nothing waiting or a refusal is an
 * answer in the body, not an error. Staff only: a start spends the
 * team's models and can open a pull request in its repository.
 * @summary Run Train Loop Link
 */
export const runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPost = async (
  slug: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostResponse> => {
  return orvalFetch<runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostResponse>(
    getRunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostUrl(slug),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationKey =
  () => ["runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPost"] as const;

export const getRunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPost
        >
      >,
      TError,
      RunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPost
      >
    >,
    TError,
    RunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getRunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPost
        >
      >,
      RunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationVariables
    > = (props) => {
      const { slug } = props ?? {};

      return runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPost(
        slug,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPost
      >
    >
  >;

export type RunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationError =
  ErrorType<HTTPValidationError>;
export type RunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationVariables =
  { slug: string };

/**
 * @summary Run Train Loop Link
 */
export const useRunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPost
        >
      >,
      TError,
      RunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof runTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPost>
  >,
  TError,
  RunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationVariables,
  TContext
> => {
  return useMutation(
    getRunTrainLoopLinkApiSettingsTeamTrainLoopLinksSlugRunPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutResponse200 =
  {
    data: TrainLoopLinkThreshold;
    status: 200;
  };

export type setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutResponseSuccess =
  setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutResponse200 & {
    headers: Headers;
  };
export type setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutResponseError =
  setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutResponse422 & {
    headers: Headers;
  };

export type setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutResponse =

    | setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutResponseSuccess
    | setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutResponseError;

export const getSetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutUrl =
  (slug: string) => {
    return `/api/settings/team/train-loop/links/${slug}/threshold`;
  };

/**
 * Set how much work the link needs waiting before its event starts
 * the job. The row is the team's config row, read by every start.
 * Staff only, as the start is.
 * @summary Set Train Loop Link Threshold
 */
export const setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPut =
  async (
    slug: string,
    trainLoopLinkThreshold: TrainLoopLinkThreshold,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutResponse> => {
    const getHeaders = (
      h?: NonNullable<RequestInit["headers"]>,
    ): Record<string, string | readonly string[]> => {
      if (!h) return {};
      if (h instanceof Headers) return Object.fromEntries(h.entries());
      if (Symbol.iterator in h) {
        return Object.fromEntries(
          Array.from(
            h as Iterable<Iterable<string>>,
            (entry) => Array.from(entry) as [string, string],
          ),
        );
      }
      const headers: Record<string, string | readonly string[]> = {};
      for (const [name, value] of Object.entries<
        string | readonly string[] | undefined
      >(h)) {
        if (value !== undefined) headers[name] = value;
      }
      return headers;
    };
    return orvalFetch<setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutResponse>(
      getSetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutUrl(
        slug,
      ),
      {
        ...options,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(options?.headers),
        },
        body: JSON.stringify(trainLoopLinkThreshold),
      },
    );
  };

export const getSetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationKey =
  () =>
    [
      "setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPut",
    ] as const;

export const getSetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPut
        >
      >,
      TError,
      SetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPut
      >
    >,
    TError,
    SetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getSetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPut
        >
      >,
      SetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationVariables
    > = (props) => {
      const { slug, data } = props ?? {};

      return setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPut(
        slug,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPut
      >
    >
  >;
export type SetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationBody =
  TrainLoopLinkThreshold;
export type SetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationError =
  ErrorType<HTTPValidationError>;
export type SetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationVariables =
  { slug: string; data: TrainLoopLinkThreshold };

/**
 * @summary Set Train Loop Link Threshold
 */
export const useSetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPut =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPut
          >
        >,
        TError,
        SetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPut
      >
    >,
    TError,
    SetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationVariables,
    TContext
  > => {
    return useMutation(
      getSetTrainLoopLinkThresholdApiSettingsTeamTrainLoopLinksSlugThresholdPutMutationOptions(
        options,
      ),
      queryClient,
    );
  };
